export default __webpack_public_path__ + "static/media/ProjectManager.79fc3b5c.png";